<script setup lang="ts">
// Models
import { Employee } from '../../models/employee'

// Data
defineProps<{
  employee: Employee
}>()
defineEmits([
    'remove-employee',
])
</script>

<template>
  <!-- class="h-32 relative col-span-1 flex flex-col rounded-md bg-white text-center border border-gray-100 cursor-pointer" -->
  <div
    class="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-3 py-3 shadow-xs focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"
    @click="$emit('remove-employee', employee)"
  >
    <div class="shrink-0">
      <img
        class="size-10 rounded-full"
        :src="employee.avatarUrl"
        alt=""
      >
    </div>
    <div class="min-w-0 flex-1">
      <a
        href="#"
        class="focus:outline-hidden"
      >
        <span
          class="absolute inset-0"
          aria-hidden="true"
        />
        <p class="text-sm font-medium text-gray-900">{{ employee.displayName }}</p>
      </a>
    </div>
  </div>
</template>